<template>
	<div class="field">
		<div class="wrap">
			<div class="label" v-text="label"/>
			<slot>
				<input v-bind="{value, disabled, type}" @input="update"/>
			</slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		type: {type: String, default: "text"},
		label: {type: String, required: true},
		value: {type: String, required: false},
		disabled: {type: Boolean, required: false}
	},
	methods: {
		update(e) {
			this.$emit("input", e.target.value);
		}
	}
};
</script>

<style lang="scss" scoped>
.field {
	width: 50%;
	height: percentage(1/3);
	border: 1px solid #F5F5F5;
	border-left: 0;
	border-top: 0;

	display: flex;
	align-items: center;
	justify-content: center;

	@include res(mobile) {
		width: 100%;
		height: auto;
		align-items: flex-start;
		border: 0;
		margin-bottom: 54px;
	}

	.wrap {
		width: 250px;
		height: 70px;

		@include res(mobile) {
			width: 100%;
			height: auto;
		}

		.label {
			color: #B1B1B1;
			font-size: 12px;
			font-weight: 500;
			text-transform: uppercase;

			@include res(mobile) {
				margin-bottom: 18px;
			}
		}

		input {
			background-color: $white1;
			appearance: none;
			width: 100%;
			border: 0;
			padding: 1em;
			padding-left: 0;
			outline: 0;
			font-size: 18px;

			@include res(mobile) {
				border-bottom: 1px solid #E2E2E2;
				padding: 0;
			}
		}
	}
}
</style>
